/**
 * 上报模块，目前支持灯塔上报和内软上报(腾讯视频、QQ看点、应用宝平台)
 * @module report
 * @example
 * import { wsReport } from "@tencent/weishi-lib";
 * wsReport.beacon.init({});
 * wsReport.softInside.init({});
 * @tutorial http://tnpm.oa.com/package/@tencent/wsbeacon
 */
import beacon from './beacon';
import softInside from './soft-inside';

export default {
  beacon,
  softInside,
};
